import { Component, OnInit } from '@angular/core';
import { ResetMeetingPinOrTokenType } from '@app/core/repositories/meeting.repository';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { PortalError } from '@app/utils/error/portal-error';
import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { Required, StringInput } from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';
import { MeetingService } from '@business/meeting/meeting.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { FormGroupTyped } from '../../../../../types/typed-forms';

@FormMapping()
class ResetPinOrTokenForm extends FormMappingModel {
  @StringInput
  @Required
  type: ResetMeetingPinOrTokenType;
}

interface ResetPinOrTokenInput {
  meetingId: number;
}

@Component({
  selector: 'portal-reset-pin-or-token',
  templateUrl: './reset-pin-or-token.component.html',
  styles: [],
  standalone: false,
})
export class ResetPinOrTokenComponent
  extends DialogComponent<ResetPinOrTokenInput, void>
  implements OnInit, ResetPinOrTokenInput
{
  meetingId!: number;

  error: PortalError | null = null;
  form!: FormGroupTyped<ResetPinOrTokenForm>;
  saving: boolean = false;

  constructor(
    private meetingService: MeetingService,
    ngbActiveModal: NgbActiveModal
  ) {
    super(ngbActiveModal);
  }

  ngOnInit(): void {
    this.form = ResetPinOrTokenForm.formGroup();
  }

  submit(): void {
    this.saving = true;

    this.meetingService
      .resetPinOrToken(this.meetingId, this.form.value.type)
      .pipe(
        finalize(() => {
          this.saving = false;
        })
      )
      .subscribe({
        error: (error) => {
          this.error = error;
        },
        next: () => {
          this.close();
        },
      });
  }
}
